webpackJsonp([159055269280251],{

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic01.928842f9.jpg";

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic02.87b41c6b.jpg";

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic03.0bd35de2.jpg";

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic04.12f40f57.jpg";

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic05.7f8f3b53.jpg";

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic06.27e9e5b7.jpg";

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic08.95398946.jpg";

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic09.c8d54f8b.jpg";

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic10.c6770d0e.jpg";

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(40);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _pic = __webpack_require__(139);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	var _pic3 = __webpack_require__(523);
	
	var _pic4 = _interopRequireDefault(_pic3);
	
	var _pic5 = __webpack_require__(524);
	
	var _pic6 = _interopRequireDefault(_pic5);
	
	var _pic7 = __webpack_require__(143);
	
	var _pic8 = _interopRequireDefault(_pic7);
	
	var _pic9 = __webpack_require__(137);
	
	var _pic10 = _interopRequireDefault(_pic9);
	
	var _pic11 = __webpack_require__(138);
	
	var _pic12 = _interopRequireDefault(_pic11);
	
	var _pic13 = __webpack_require__(140);
	
	var _pic14 = _interopRequireDefault(_pic13);
	
	var _pic15 = __webpack_require__(141);
	
	var _pic16 = _interopRequireDefault(_pic15);
	
	var _pic17 = __webpack_require__(142);
	
	var _pic18 = _interopRequireDefault(_pic17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Elements = function Elements(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'Productos'
	            ),
	            _react2.default.createElement('meta', { name: 'products', content: 'Page with all the products' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { id: 'main', className: 'alt' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one', className: 'tiles' },
	                _react2.default.createElement(
	                    'article',
	                    { style: { backgroundImage: 'url(' + _pic18.default + ')' } },
	                    _react2.default.createElement(
	                        'header',
	                        { className: 'major' },
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'AlphaCaputra UDP Feed'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'The fastest way of getting reliable news, click her for a free trial'
	                        )
	                    ),
	                    _react2.default.createElement(_gatsbyLink2.default, { to: '/contacto', className: 'link primary' })
	                ),
	                _react2.default.createElement(
	                    'article',
	                    { style: { backgroundImage: 'url(' + _pic2.default + ')' } },
	                    _react2.default.createElement(
	                        'header',
	                        { className: 'major' },
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'AlphaCaptura Clicker'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'AC Clicker is made for point and click, super fast via Metatrader 4 (all rights reserved)'
	                        )
	                    ),
	                    _react2.default.createElement(_gatsbyLink2.default, { to: '/contacto', className: 'link primary' })
	                ),
	                _react2.default.createElement(
	                    'article',
	                    { style: { backgroundImage: 'url(' + _pic12.default + ')' } },
	                    _react2.default.createElement(
	                        'header',
	                        { className: 'major' },
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Crytocurrency'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Machine Learning prediction feed / Buy and sell in big blocks'
	                        )
	                    ),
	                    _react2.default.createElement(_gatsbyLink2.default, { to: '/contacto', className: 'link primary' })
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                { id: 'three' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'header',
	                        { className: 'major' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Trading is risky'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'There is a substantial risk of loss in futures and forex trading. Online trading of stocks and options is extremely risky. Assume you will lose money. Don\'t trade with money you cannot afford to lose.'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Elements;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-productos-jsx-23768554630c1b484aac.js